import isNil from "lodash-es/isNil";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import weui from "weui.js";
import {
  Cell,
  CellBody,
  CellButton,
  CellFooter,
  CellHeader,
  Cells,
  CellsTitle,
  Label,
  Loadmore,
  MediaBoxInfo
} from "../../components/weui";
import { userService } from "../../services";
import {
  refreshBanksOfB2b,
  selectBanksOfB2b,
  selectPayChannels
} from "../../stores";
import { urls } from "../../urls";
import {
  PayChannels,
  formatCurrency,
  formatDateTime,
  formatPrice,
  formatUsage2,
  getAxiosError
} from "../../utils";

import "./index.css";

export const PaymentDetail = (props) => {
  const navigate = useNavigate();
  const { orderNo } = useParams();
  const dispatch = useDispatch();
  const PayChannelCodings = useSelector(selectPayChannels);
  const BankCodings = useSelector(selectBanksOfB2b);
  const [loading, setLoading] = useState(true);
  const [order, setOrder] = useState();

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const res = await userService.getOrderDetail(orderNo);
      setOrder(res.data);
    } catch (err) {
      weui.topTips(getAxiosError(err));
    } finally {
      setLoading(false);
    }
  }, [orderNo, setOrder, setLoading]);

  useEffect(() => {
    if (BankCodings.length === 0) {
      dispatch(refreshBanksOfB2b());
    }

    reload();
  }, [BankCodings, dispatch, reload]);

  const formatDetails = useCallback(order => {
    const result = [];
    if (!order) return result;

    const isPrepaidMoney = order.prepaidType === 1;
    const hasSurcharge = (order.surcharge * 100) > 0;
    const qtyUnit = isPrepaidMoney ? "金额" : "数量";

    result.push({ title: "缴费编号", value: order.orderNo });
    result.push({ title: "订单时间", value: formatDateTime(new Date(order.createTime)) });

    result.push({ title: `充值${qtyUnit}`, value: isPrepaidMoney ? formatCurrency(order.quantity) : formatUsage2(order.quantity) });

    if (!isPrepaidMoney) {
      result.push({ title: "充值单价", value: formatPrice(order.price) });
      result.push({ title: "充值金额", value: formatCurrency(order.rechargeMoney) });
    }

    if (order.transFeeUser > 0) result.push({ title: "手续费", value: formatCurrency(order.transFeeUser) });
    result.push({ title: "实付金额", value: formatCurrency(order.totalMoney) });

    if (hasSurcharge) {
      result.push({ title: `下发${qtyUnit}`, value: formatCurrency(order.sendMoney) });
      result.push({ title: "物业费", value: formatCurrency(order.surcharge) });
    }

    if (!isNil(order.payChannel)) {
      const chnName = PayChannelCodings.find(c => c.id === order.payChannel)?.name ?? `未知[${order.payChannel}]`;
      result.push({ title: "支付方式", value: chnName });
      if (order.payChannel === PayChannels.B2BHF) {
        const bankName = BankCodings.find(c => c.code === order.bankType)?.name ?? `未知[${order.bankType}]`;
        result.push({ title: "支付银行", value: bankName });
      }
    }

    result.push({ title: "订单状态", value: order.orderState });

    if (order.payTime) {
      result.push({ title: "支付时间", value: formatDateTime(new Date(order.payTime)) });
    }

    if (order.pmsTime) {
      result.push({ title: "下发时间", value: formatDateTime(new Date(order.pmsTime)) });
    }

    return result;
  }, [PayChannelCodings, BankCodings]);

  const details = formatDetails(order);

  if (loading) {
    return <Loadmore line loading>加载中...</Loadmore>;
  }

  return (
    <>
      <Cells>
        <Cell>
          <CellBody>
            <Label>{ order?.name ?? "..." }</Label>
            { /*<CellDescription>{order?.address ?? '...'}</CellDescription>*/ }
            <MediaBoxInfo className="mt-2" infos={ [`${order?.meterClass}`, `${order?.meterNo}`, `|${order?.corpName}`] } />
          </CellBody>
        </Cell>
      </Cells>

      <CellsTitle>缴费信息</CellsTitle>
      <Cells>
        {
          details.length > 0 &&
          details.map((d, idx) => (
            <Cell key={ idx }>
              <CellHeader>
                <Label>{ d.title }</Label>
              </CellHeader>
              <CellBody></CellBody>
              <CellFooter>{ d.value }</CellFooter>
            </Cell>
          ))
        }
      </Cells>

      <Cells>
        {
          order.orderState === "未支付" && <CellButton type="primary" onClick={ e => navigate(urls.rechargeChannel(order.orderNo)) }>继续支付</CellButton>
        }
      </Cells>
    </>
  );
};
